import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Typography,
  CircularProgress,
  Grid,
  Card,
  CardContent,
} from '@material-ui/core';
import axios from 'axios';
import envConfig from '../../../bin/env.config';
import { useSelector } from 'react-redux';
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    borderRadius: 16,
    boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
    background: '#fff',
  },
  value: {
    fontSize: '2.2rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    // Color can be dynamic, but for now, use a gradient of colors
    color: theme.palette.primary.main,
  },
  label: {
    fontSize: '1rem',
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 600,
  },
  gridItem: {
    flex: '0 0 20%',
    maxWidth: '20%',
    padding: theme.spacing(1.5),
    boxSizing: 'border-box',
  },
}));

const CustomerDataFreshness = ({ project }) => {
  const classes = useStyles();
  const token = useSelector((state) => state.session.token);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/data-freshness-reporting/customer-data/summary?user_type_id=${project.user_type_id}`, {
          headers: {
            Authorization: token,
          },
        });
        setData(response.data.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch customer data freshness information');
        setLoading(false);
      }
    };

    fetchData();
  }, [project]);

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <Paper className={classes.root}>
        <Typography color="error">{error}</Typography>
      </Paper>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={3} style={{ display: 'flex', flexWrap: 'wrap' }}>
        {data && Object.entries(data).map(([key, value], idx) => {
          // Assign a color for each card value (optional, for variety)
          const colors = ['#E9408F', '#3B82F6', '#22C55E', '#A259E9', '#F59E42'];
          const valueColor = colors[idx % colors.length];
          return (
            <div className={classes.gridItem} key={key}>
              <Card className={classes.card} elevation={2}>
                <CardContent style={{ textAlign: 'center' }}>
                  <Typography
                    className={classes.value}
                    style={{ color: valueColor }}
                    variant="h3"
                    component="div"
                  >
                    {value}
                  </Typography>
                  <Typography className={classes.label} variant="subtitle1">
                    {key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                  </Typography>
                </CardContent>
              </Card>
            </div>
          );
        })}
      </Grid>
    </div>
  );
};

export default CustomerDataFreshness; 